import styled, { css } from "styled-components";
import { Paragraph, Heading } from "../../../atoms/Typography/Typography.styles";

interface HeroQuaternaryProps {
  colorScheme?: string;
  maskType?: string;
}

export const HeroQuaternary = styled.div<HeroQuaternaryProps>`
  padding: ${({ theme }) => theme.rem(32, 0)};
  background-color: ${({ theme, colorScheme }) => theme.colorScheme[colorScheme || 'darkGreen'].surface.inside};

  ${Paragraph},
  ${Heading} {
    color: ${({ theme, colorScheme }) => theme.colorScheme[`${colorScheme}`].surface.text.base.primary};
  }

  ${({ theme }) => theme.mediaQuery.lg(`
    padding: ${theme.rem(32, 0)};
  `)}
`

export const HeroQuaternaryMaskWrapper = styled.div<HeroQuaternaryProps>`
  width: 100%;
  position: relative;
  height: ${({ maskType, theme }) => maskType === 'circle' ? '100%' : theme.rem(250)};
  max-height: ${({ theme }) => theme.rem(500)};
  margin: 0 auto;
  aspect-ratio: 4 / 4;
  overflow: hidden;

  ${({ maskType }) => maskType && css`
    mask-image: url('/masks/mask-${maskType}.svg');
    mask-size: 100%;
    mask-repeat: no-repeat;
    mask-position: center;
  `}

  ${({ theme, maskType }) => theme.mediaQuery.xl(`
    max-width: 100%;
    width: ${maskType === 'circle' ? 'auto' : '80%'};
    height: ${theme.rem(360)};
  `)};

  img {
    object-fit: cover;
    object-position: center;
  }
`

export const HeroQuaternaryContent = styled.div`
  padding-top: ${({ theme }) => theme.rem(24)}; 

  ${({ theme }) => theme.mediaQuery.xl(`
    padding-top: 0;
  `)}
`
 